import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Section, Container, Eyebrow, RevealHeading } from "@/components/primitives";
import { CTASection } from "@/components/CTASection";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";
import { IMAGES } from "@/data/site";

export default function Reports() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/reports").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <>
      <Seo
        title="Reports | GovX Nigeria"
        description="Research designed for decision-makers — state of governance, delivery, performance and citizen experience reports on Nigeria."
      />
      <section className="relative bg-govx-black pt-[74px] text-govx-paper grain">
        <Container className="relative z-10 py-20 lg:py-24">
          <Eyebrow dark>GovX Reports</Eyebrow>
          <RevealHeading
            lines={["Research Designed For", "Decision-Makers."]}
            className="mt-7 font-display text-4xl font-medium leading-[1.02] tracking-tight sm:text-6xl"
          />
        </Container>
      </section>

      <Section className="py-20 lg:py-28">
        <Container>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {items.map((it, i) => (
              <motion.div
                key={it.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                data-testid={`report-card-${i}`}
                className="group flex flex-col border border-govx-charcoal/10 bg-white"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={it.image_url || IMAGES.lagosBW}
                    alt={it.title}
                    className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0"
                  />
                  <span
                    className={`absolute left-4 top-4 rounded-full px-3 py-1 font-mono text-[0.6rem] uppercase tracking-wider ${
                      it.status === "Available"
                        ? "bg-govx-green text-white"
                        : "bg-govx-black/70 text-govx-lime backdrop-blur"
                    }`}
                  >
                    {it.status}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <div className="font-mono text-[0.62rem] uppercase tracking-[0.16em] text-govx-green">
                    {it.category} · {it.year}
                  </div>
                  <h3 className="mt-3 font-display text-xl font-medium leading-snug tracking-tight">{it.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-govx-charcoal/60">{it.description}</p>
                  <span className="mt-6 font-mono text-xs uppercase tracking-wider text-govx-grey">
                    {it.status === "Available" ? "Download report" : "Coming Soon"}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </Section>

      <CTASection
        eyebrow="Reports"
        title={["Research that helps", "decisions get made."]}
        cta="Talk to GovX Intelligence"
      />
    </>
  );
}
